import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        addQueue: builder.mutation({
            query: (body) => ({
                url: `queue/addQueue`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getQueueById: builder.mutation({
            query: (body) => ({
                url: `queue/getQueueById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        updateQueue: builder.mutation({
            query: (body) => ({
                url: `queue/updateQueue`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getQueueList: builder.mutation({
            query: (body) => ({
                url: `queue/getAllQueue`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        updateQueueStatus: builder.mutation({
            query: (body) => ({
                url: `queue/updateStatus`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getQueueDropdown: builder.query({
            query: () => ({
                url: `queue/getDropdownDetails`,
                method: "GET",
            }),
            providesTags: ["QueueDropdown"],
        }),

    })

})

export const { useAddQueueMutation, useGetQueueByIdMutation, useUpdateQueueMutation, useGetQueueListMutation, useUpdateQueueStatusMutation, useGetQueueDropdownQuery } = Api